export const Currency = {
  EUR: 'EUR',
  GBP: 'GBP',
  NOK: 'NOK',
  USD: 'USD',
  ILS: 'ILS',
  CHF: 'CHF',
  MXN: 'MXN',
  SEK: 'SEK',
  HUF: 'HUF',
  DKK: 'DKK',
  DOP: 'DOP',
  PLN: 'PLN',
  ALL: 'ALL',
  ZAR: 'ZAR',
  AED: 'AED',
};

export const CurrencyById = {
  0: 'Undefined',
  1: 'EUR',
  2: 'GBP',
  3: 'NOK',
  4: 'ILS',
  5: 'CHF',
  6: 'MXN',
  7: 'SEK',
  8: 'HUF',
  9: 'USD',
  10: 'DKK',
  11: 'DOP',
  12: 'PLN',
  13: 'ALL',
  14: 'ZAR',
  15: 'AED',
};

export const CurrencyIdByString = {
  Undefined: 0,
  EUR: 1,
  GBP: 2,
  NOK: 3,
  ILS: 4,
  CHF: 5,
  MXN: 6,
  SEK: 7,
  HUF: 8,
  USD: 9,
  DKK: 10,
  DOP: 11,
  PLN: 12,
  ALL: 13,
  ZAR: 14,
  AED: 15,
};

export const PriceMultiplierByCurrency = {
  EUR: 1,
  GBP: 1,
  NOK: 10,
  ILS: 3.5,
  CHF: 1,
  MXN: 20,
  SEK: 15,
  HUF: 380,
  USD: 1,
  DKK: 7.5,
  DOP: 62,
  PLN: 4.4,
  ALL: 100,
  ZAR: 20,
  AED: 4,
};

export const DEFAULT_CURRENCY = Currency.EUR;
